
import { mapGetters } from "vuex";
import UiInputWrapper from "~/components/UI/UiInputWrapper";
import UiInput from "~/components/UI/UiInput";
import UiButton from "@/components/UI/UiButton.vue";
import TrackingComponent from "@/components/pages/order-tracking/TrackingComponent.vue";
import UiSpinner from "~/components/UI/UiSpinner";
import useEvents from "~/mixins/useEvents";
export default {
  components: {
    UiInputWrapper,
    UiInput,
    UiButton,
    TrackingComponent,
    UiSpinner,
  },
  mixins: [useEvents],
  async asyncData({ query, $api }) {
    const getData = async () => {
      if (!query.email || !query.number) {
        return null;
      }
      try {
        const { data } = await $api.orders.getTrackingOrder({ ...query });
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };
    return {
      form: {
        email: "",
        number: "",
      },
      orderData: await getData(),
      loading: false,
      showForm: false,
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "auth/getUserInfo",
    }),
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val && val.email) {
          this.form.email = val.email;
        }
      },
      immediate: true,
    },
  },
  mounted () {
    this.visitEvent();
  },
  methods: {
    async getOrderData(params) {},
    async onSubmit() {
      this.loading = true;
      try {
        const { data } = await this.$api.orders.getTrackingOrder({
          ...this.form,
        });
        this.orderData = data.data;
      } catch (error) {
        console.log("err - ", error?.response?.data?.errors);
        if (
          error.response.data.errors[0].property &&
          Object.hasOwn(this.form, error.response.data.errors[0].property)
        ) {
          this.$refs.updatePasswordForm.setErrors({
            [error.response.data.errors[0].property]:
              error.response.data.errors[0].message,
          });
        } else {
          this.$alert({
            title: this.$t("error"),
            text: error?.response?.data?.errors[0],
          });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
